import React, { useContext } from 'react'
import { MouseDownContext } from '../LookupTable/mouseDownContext'
import { Icon } from 'semantic-ui-react'

export const TableCellCheckbox = (props: any) => {
  const isMouseDown = useContext(MouseDownContext)

  return (
    <div
      data-testid="table-cell-checkbox"
      onClick={() => {
        if (!props.selected) {
          props.onAdd({
            id: props.row.values.id,
            name: props.row.values['attributes.name'],
            brand: props.row.values['attributes.brand'],
            brand_subtype: props.row.values['attributes.brand_subtype'],
            product_subtype: props.row.values['attributes.product_subtype'],
            image_urls: props.row.image_urls,
            lineage: props.row.values['attributes.lineage'].toLowerCase(),
          })
        } else {
          props.onRemove(props.row.values.id)
        }
      }}
      onMouseOver={() => {
        if (isMouseDown && !props.selected) {
          props.onAdd({
            id: props.row.values.id,
            name: props.row.values['attributes.name'],
            brand: props.row.values['attributes.brand'],
            brand_subtype: props.row.values['attributes.brand_subtype'],
            product_subtype: props.row.values['attributes.product_subtype'],
            image_urls: props.row.image_urls,
            lineage: props.row.values['attributes.lineage'].toLowerCase(),
          })
        }
      }}
    >
      <label htmlFor={`table-cell-checkbox-${props.row.values.id}`}>
        <Icon name="plus" />
      </label>
      <input
        type="checkbox"
        id={`table-cell-checkbox-${props.row.values.id}`}
        checked={props.selected}
        className="add-to-queue-checkbox"
        data-testid={`table-cell-checkbox-${props.row.values.id}`}
        readOnly
      />
    </div>
  )
}
